module.exports = __webpack_public_path__ + "images/avatars/female/1.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/1.svg
// module id = ClZ7
// module chunks = 51